<template>
    <div class="div-home">
        <loader-component v-if="showLoader"></loader-component>

        <div v-else class="wrapper-parent">
            <!--<div v-if="customerGroupId != 2 || customerGroupId == 1" class="modal fade" id="alaramModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLongTitle">هشدار</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="content-section default">
                                        <form class="form-account">
                                            <div class="row">
                                                <p>
                                                    برای دیدن قیمت های همکاری با چت آنلاین یا تماس با پشتیبانی در ارتباط باشید.
                                                </p>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
            <h1 style="display:none !important">{{baseInfo.ShopName}}</h1>
            <!-- responsive-header -->
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->
            <div class="wrapper default">
                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar-component></navbar-component>
                </header>
                <!-- header -->
                <main class="main default">
                    <div class="container">
                        <!-- banner -->
                        <div v-if="banners != null && banners[0] != null && banners[0].IsActive == true && banners[0].PicPath != null" class="row banner-ads">
                            <div class="col-12">
                                <section class="banner">
                                    <a target="_blank" :href="banners[0].URL" :title="banners[0].Alt">
                                        <img v-if="banners != null && banners[0] != null && banners[0].IsActive == true && banners[0].PicPath != null" :src="banners[0].PicPath" :alt="banners[0].Alt" :title="banners[0].Alt">
                                    </a>
                                </section>
                            </div>
                        </div>
                        <!-- banner -->
                        <div class="row">
                            <div class="col-12 col-lg-12 order-1 order-lg-1">
                                <sliders></sliders>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 col-lg-3">
                                <div class="sidebar-inner default">
                                    <div class="widget-banner widget card" v-if="banners != null && banners[2] != null && banners[2].IsActive == true && banners[2].PicPath != null">
                                        <a target="_blank" :href="banners[2].URL" :title="banners[2].Alt">
                                            <img style="" class="img-fluid" :src="banners[2].PicPath" :alt="banners[2].Alt" :title="banners[2].Alt">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3  f-f-pa-l">
                                <div class="sidebar-inner default">
                                    <div style="" class="widget-banner widget card" v-if="banners != null && banners[1] != null && banners[1].IsActive == true && banners[1].PicPath != null">
                                        <a target="_blank" :href="banners[1].URL" :title="banners[1].Alt">
                                            <img style="" class="img-fluid" :src="banners[1].PicPath" :alt="banners[1].Alt" :title="banners[1].Alt">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3">
                                <div class="widget-banner card" v-if="banners != null && banners[8] != null && banners[8].IsActive == true && banners[8].PicPath != null">
                                    <a :href="banners[8].URL" target="_blank">
                                        <img class="img-fluid" :src="banners[8].PicPath" :alt="banners[8].Alt">
                                    </a>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3 f-f-pa-l">
                                <div class="widget-banner card" v-if="banners != null && banners[9] != null && banners[9].IsActive == true && banners[9].PicPath != null">
                                    <a :href="banners[9].URL" target="_blank">
                                        <img class="img-fluid" :src="banners[9].PicPath" :alt="banners[9].Alt">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<special-brands></special-brands>-->
                    <!--<div class="row">
                        <aside class="sidebar col-12 col-sm-12 col-lg-3">
                            <div class="sidebar-inner default">
                                <div style="" class="widget-banner widget card" v-if="banners != null && banners[1] != null && banners[1].IsActive == true && banners[1].PicPath != null">
                                    <a target="_blank" :href="banners[1].URL" :title="banners[1].Alt">
                                        <img style="" class="img-fluid" :src="banners[1].PicPath" :alt="banners[1].Alt" :title="banners[1].Alt">
                                    </a>
                                </div>

                            </div>
                            <div class="sidebar-inner default">
                                <div class="widget-banner widget card" v-if="banners != null && banners[2] != null && banners[2].IsActive == true && banners[2].PicPath != null">
                                    <a target="_blank" :href="banners[2].URL" :title="banners[2].Alt">
                                        <img style="" class="img-fluid" :src="banners[2].PicPath" :alt="banners[2].Alt" :title="banners[2].Alt">
                                    </a>
                                </div>
                            </div>
                        </aside>
                        <div class="amg-pad-rtl col-12 col-lg-9">
                            <amazing-offers></amazing-offers>
                            <responsive-AmazingOffers></responsive-AmazingOffers>
                        </div>
                    </div>-->
                    <div class="row">
                        <div class="col-12 col-lg-12" style="padding-left:0;padding-right:0">
                            <amazing-Offers-FullWidth></amazing-Offers-FullWidth>
                        </div>
                    </div>
                    <div class="row banner-ads">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6 col-lg-3">
                                    <div class="widget-banner card" v-if="banners != null && banners[4] != null && banners[4].IsActive == true && banners[4].PicPath != null">
                                        <a target="_blank" :href="banners[4].URL" :title="banners[4].Alt">
                                            <img class="img-fluid" :src="banners[4].PicPath" :alt="banners[4].Alt" :title="banners[4].Alt">
                                        </a>
                                    </div>
                                </div>
                                <div class="col-6 col-lg-3">
                                    <div class="widget-banner card" v-if="banners != null && banners[5] != null && banners[5].IsActive == true && banners[5].PicPath != null">
                                        <a target="_blank" :href="banners[5].URL" :title="banners[5].Alt">
                                            <img class="img-fluid" :src="banners[5].PicPath" :alt="banners[5].Alt" :title="banners[5].Alt">
                                        </a>
                                    </div>
                                </div>
                                <div class="col-6 col-lg-3">
                                    <div class="widget-banner card" v-if="banners != null && banners[6] != null && banners[6].IsActive == true && banners[6].PicPath != null">
                                        <a target="_blank" :href="banners[6].URL" :title="banners[6].Alt">
                                            <img class="img-fluid" :src="banners[6].PicPath" :alt="banners[6].Alt" :title="banners[6].Alt">
                                        </a>
                                    </div>
                                </div>
                                <div class="col-6 col-lg-3">
                                    <div class="widget-banner card" v-if="banners != null && banners[7] != null && banners[7].IsActive == true && banners[7].PicPath != null">
                                        <a target="_blank" :href="banners[7].URL" :title="banners[7].Alt">
                                            <img class="img-fluid" :src="banners[7].PicPath" :alt="banners[7].Alt" :title="banners[7].Alt">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <widget-product :sectionNumber="0"></widget-product>
                        </div>
                        <div class="col-12">
                            <widget-product :sectionNumber="1"></widget-product>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="widget-banner card" v-if="banners != null && banners[3] != null && banners[3].IsActive == true && banners[3].PicPath != null">
                                <a target="_blank" :href="banners[3].URL" :title="banners[3].Alt">
                                    <img class="img-fluid" :src="banners[3].PicPath" :alt="banners[3].Alt" :title="banners[3].Alt">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-12">
                            <div class="row">
                                <div class="col-12">
                                    <widget-product :sectionNumber="2"></widget-product>
                                </div>
                                <div class="col-12">
                                    <widget-product :sectionNumber="3"></widget-product>
                                </div>
                            </div>
                            <div class="banner-ads">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="widget-banner card" v-if="banners != null && banners[12] != null && banners[12].IsActive == true && banners[12].PicPath != null">
                                            <a :href="banners[12].URL" target="_blank">
                                                <img class="img-fluid" :src="banners[12].PicPath" :alt="banners[12].Alt">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <widget-product :sectionNumber="4"></widget-product>
                                    </div>
                                    <div class="col-12">
                                        <widget-product :sectionNumber="5"></widget-product>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="widget-banner card" v-if="banners != null && banners[10] != null && banners[10].IsActive == true && banners[10].PicPath != null">
                                            <a :href="banners[10].URL" target="_blank">
                                                <img class="img-fluid" :src="banners[10].PicPath" :alt="banners[10].Alt">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <widget-product :sectionNumber="6"></widget-product>
                                    </div>
                                    <div class="col-12">
                                        <widget-product :sectionNumber="7"></widget-product>
                                    </div>
                                </div>
                                <div class="row banner-ads">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="widget-banner card" v-if="banners != null && banners[11] != null && banners[11].IsActive == true && banners[11].PicPath != null">
                                                    <a :href="banners[11].URL" target="_blank">
                                                        <img class="img-fluid" :src="banners[11].PicPath" :alt="banners[11].Alt">
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <widget-product :sectionNumber="8"></widget-product>
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <widget-product :sectionNumber="9"></widget-product>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div v-if="homeMetaDescriptions.IsActive">
                            <div class="col-12 col-lg-12 col-md-12 col-xs-12" style="margin-bottom:25px;margin-top:25px">
                                <div v-html="homeMetaDescriptions.Description">

                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-12">
                            <div class="banner-ads">
                                <div class="row">
                                    <div class="col-12">
                                        <blogs></blogs>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <special-brands></special-brands>
                    </div>
                </main>
                <footer-component></footer-component>
                <footer-fixnav-component></footer-fixnav-component>
            </div>
        </div>

    </div>
</template>

<script>
    import specialBrands from './specialBrands.vue';
    import sliders from './sliders.vue';
    import blogs from './blogs.vue';
    import amazingOffers from './amazingOffers.vue';
    import responsiveamazingOffers from './responsiveamazingOffers.vue';
    import widgetProduct from './widgetProduct.vue';
    import widgetSuggestion from './widgetSuggestion.vue';
    import newestProduct from './newestProduct.vue';
    import amazingOffersFullWidth from './amazingOffersFullWidth.vue'
    import { initialSite } from "../../module/initialSite";
    import { httpPromise } from "../../module/httpUtility";

    export default {
        data() {
            return {
                banner: 0,
                showLoader: false,
            }
        },
        components: {
            'special-brands': specialBrands,
            'sliders': sliders,
            'amazing-offers': amazingOffers,
            'widget-product': widgetProduct,
            'widget-suggestion': widgetSuggestion,
            'responsive-AmazingOffers': responsiveamazingOffers,
            'blogs': blogs,
            'widget-newest-Product': newestProduct,
            'amazing-Offers-FullWidth': amazingOffersFullWidth
        },
        computed: {
            homeMetaDescriptions: function () {
                return this.$store.getters.readHomeMetaDescriptions;
            },
            banners: function () {
                return this.$store.getters.readBanners;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        beforeMount: function () {
            httpPromise(this, '/v1/ContentManagement/Contents/Read', 'get', '',
                response => {
                    //  localStorage.setItem('RedirectPages', JSON.stringify(response.data.Value.RedirectPages));
                    if (response.data.Value.BaseInfos == null) {
                        component.$router.push('/webServiceError');
                        component.$data.showLoader = false;
                    } else {
                        if (response.data.Value.BaseInfos.keywords != null) {
                            $('meta[name="keywords"]').attr("content", response.data.Value.BaseInfos.keywords);
                        } else {
                            $('meta[name="keywords"]').attr("content", ' خرید تجهیزات آشپزخانه صنعتی با بهترین قیمت و تضمین کیفیت');
                        }
                        if (response.data.Value.BaseInfos.MetaTitle != null) {
                            createPageTitle(response.data.Value.BaseInfos.MetaTitle);
                        } else {
                            createPageTitle('شپزخانه نقره‌ای | تجهیزات آشپزخانه صنعتی | مشاوره و قیمت رقابتیخرید تجهیزات آشپزخانه صنعتی با بهترین قیمت و تضمین کیفیت');
                        }
                        if (response.data.Value.BaseInfos.MetaDescription != null) {
                            $('meta[name="description"]').attr("content", response.data.Value.BaseInfos.MetaDescription);
                        } else {
                            $('meta[name="description"]').attr("content", " خرید تجهیزات آشپزخانه صنعتی با بهترین قیمت و تضمین کیفیت");
                        }
                    }
                },
                response => {

                }
            );

            initialSite(this);


        }
    }
</script>

<style scoped>
    .amg-pad-rtl {
        padding-right: 0;
    }

    .pad-left {
        padding-left: 0;
    }

    @media only screen and (min-width: 0px) and (max-width: 991px) {
        .amg-pad-rtl, .pad-slider {
            padding-right: 15px !important;
        }
    }

    @media only screen and (min-width: 0px) and (max-width: 991px) {
        .pad-left {
            padding-left: 15px;
        }
    }

    .pad-slider {
        padding-right: 0;
    }

    header.main-header {
        padding: 15px 0 0 0;
        background-color: #fff;
        margin-bottom: 15px;
    }
</style>